import React from 'react';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

import { DialogEditContext } from '../../common';

interface EditModeProps {}

export function EditMode(props: Readonly<EditModeProps>) {
  const context = React.useContext(DialogEditContext);

  if (!context) {
    throw new Error('EditMode must be used inside DialogEditWrapper');
  }

  const { isEditMode, setIsEditMode } = context;
  const theme = useTheme();
  const { t } = useTranslation('cta');

  const handleSwitchMode = () => {
    setIsEditMode((prev) => !prev);
  };

  return (
    <Button
      size="small"
      variant="outlined"
      color="uncolored"
      onClick={handleSwitchMode}
      startIcon={isEditMode ? <theme.icons.edit /> : <theme.icons.see />}
    >
      {t(`${isEditMode ? 'edit' : 'see'} mode`)}
    </Button>
  );
}
